import { createSlice } from '@reduxjs/toolkit'
import { LESSON_AUDIO_PLAYING_STATUS } from 'src/constants/lesson.constant'

// Initial state
const initialState = {
  storyLesson_currentAudioUrl: null,
  storyLesson_playingStatus: LESSON_AUDIO_PLAYING_STATUS.STOPPED,
}

// slice
export const storyLessonSlice = createSlice({
  name: 'storyLesson',
  initialState,
  reducers: {
    storyLesson_setCurrentAudioUrl(state, action) {
      state.storyLesson_currentAudioUrl = action.payload
    },
    storyLesson_setPlayingStatus(state, action) {
      state.storyLesson_playingStatus = action.payload
    },

    storyLesson_reset: () => initialState,
  },
  extraReducers: builder => {},
})

export const storyLesson_reducerActions = storyLessonSlice.actions

export const storyLesson_selectState = state => state.storyLesson
